import React, { Component } from 'react';
import { array, bool, func, object } from 'prop-types';
import Rule from './Rule/Rule';
import './RulesList.scss';

class RulesList extends Component {
  static propTypes = {
    createRule: func,
    isSelected: bool,
    openDeleteModal: func,
    openSettingsModal: func,
    rules: array,
    selectedRule: object,
    setSelectedRule: func,
    toggleShowSelected: func,
    history: object
  };

  render() {
    const {
      isSelected,
      rules,
      selectedRule,
      openDeleteModal,
      openSettingsModal,
      createRule,
      setSelectedRule,
      toggleShowSelected
    } = this.props;

    if (rules.length) {
      return (
        <div className="rules__list">
          {rules.map(rule => (
            <Rule
              className={selectedRule && selectedRule.id === rule.id ? 'rule rule__selected' : 'rule'}
              history={this.props.history}
              isSelected={isSelected}
              key={rule.id}
              openDeleteModal={openDeleteModal}
              openSettingsModal={openSettingsModal}
              rule={rule}
              setSelectedRule={setSelectedRule}
              toggleShowSelected={toggleShowSelected}
            />
          ))}
        </div>
      );
    } else {
      return (
        <div className="rules__list">
          <div className="rules__list-empty">
            You do not have any rules to view.
            <br />
            Please click <a onClick={createRule}> create new </a> to make a new rule.
          </div>
        </div>
      );
    }
  }
}

export default RulesList;
